// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input","Label":"Label","InputElement":"InputElement","Invalid":"Invalid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/UI/Input/Input.css
// module id = 603
// module chunks = 0